export default class GetAsignacionesBySubsede {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idSubSede) {
    try {
      const result = await this.#repository.getAsignacionesBySubsede(idSubSede)
      return result
    } catch (error) {
      console.error('Error al obtener las asignaciones de la subsede:', error)
      throw error
    }
  }
}
